import { useEffect, useRef, useState } from 'react';
import useDocumentTitle from '../../../../hooks/useDocumentTitle';
import { ProductsService } from '../../../../services/ProductsService';
import { useLoader } from '../../../../context/LoaderContext';
import { ToasterService } from '../../../../services/ToasterService';
import { useNavigate } from 'react-router-dom';

export default function UseProductCartPage() {
  const navigate = useNavigate();
  useDocumentTitle('Namasteji Manikchand - My Cart');
  const userLoginData = localStorage.getItem('userLoginData');
  const [selectedFilter, setSelectedFilter] = useState<any>('All');
  const { loading, setLoading } = useLoader();
  const [cartDataArr, setCartDataArr] = useState<any>({});
  const parsedUserLoginData = useRef<any>({});
  const listOfCoupen = useRef<any>([]);
  const appliedCouponName = useRef<string>(null);
  const [inputCode, setInputCode] = useState('');
  const [showCoupenModalMobile, setShowCoupenModalMobile] = useState<boolean>(false);
  const [showNullDivNotProduct, setShowNullDivNotProduct] = useState<boolean>(false);

  useEffect(() => {
    if (userLoginData) {
      parsedUserLoginData.current = JSON.parse(userLoginData);
    }
    getProductsList();
  }, []);

  async function getProductsList() {
    if (parsedUserLoginData.current && parsedUserLoginData.current?.customer_id) {
      try {
        setLoading(true);
        const resp = await ProductsService.GetCustomerProductCartList(parsedUserLoginData.current?.customer_id);
        setLoading(false);
        if (resp && resp.data) {
          if (resp && resp.data && resp.data.cart && Object.keys(resp.data.cart).length > 0) {
            if (resp.data.list_of_coupon && resp.data.list_of_coupon.length > 0) {
              listOfCoupen.current = resp.data.list_of_coupon;
            }
            if (resp.data.apply_coupon_code && resp.data.apply_coupon_code !== null) {
              appliedCouponName.current = resp.data.apply_coupon_code?.coupon_name;
              // console.log('appliedCouponName.current', appliedCouponName.current)
            }
            console.log('resp.data?.cart', resp.data?.cart);

            setCartDataArr(resp.data?.cart);
          } else {
            setShowNullDivNotProduct(true);
            // ToasterService.Error('Cart Empty Please Add Item');
            // navigate('/products');
          }
        } else if (resp && resp?.message && resp?.message.status_code === 404) {
          // ToasterService.Error('Cart Empty Please Add Item');
          setShowNullDivNotProduct(true);
          // navigate('/products');
        } else {
          setShowNullDivNotProduct(true);
          // ToasterService.Error('Temporary issue, try again later.');
          // navigate('/home');
        }
      } catch (error) {
        // console.log(error)
        setLoading(false);
        ToasterService.Error('Server Error! Please wait....');
      }
    } else {
      // ToasterService.Error('Please Login');
      navigate('/login');
    }
  }

  const cartItemPlusMinus = async (qyt: any, item_code: any, callFor: string) => {
    try {
      setLoading(true);
      const payload = {
        customer_id: parsedUserLoginData.current.customer_id,
        items: [
          {
            item_code: item_code,
            qty: qyt,
          },
        ],
      };
      const resp = await ProductsService.AddToCart(payload);
      // console.log('Resp Plus Minus', resp);
      setLoading(false);
      if (resp && resp.status_code && resp.status_code === 200) {
        if (resp && resp.data && resp.data.cart && Object.keys(resp.data.cart).length > 0) {
          const updated_quotation_items = resp.data?.cart?.items;
          localStorage.setItem('quotation_items', JSON.stringify(updated_quotation_items));
          setCartDataArr(resp.data?.cart);
        } else {
          ToasterService.Error('Something Else try again sometime');
        }
      } else if (
        resp &&
        resp.message &&
        resp.message.status_code &&
        resp.message.status_code === 200 &&
        resp.message.deleted === true
      ) {
        setShowNullDivNotProduct(true);
        localStorage.removeItem('quotation_items');
      } else {
        ToasterService.Error('Something Else try again sometime');
      }
    } catch (error) {
      setLoading(false);
      ToasterService.Error('Server Error!..');
    }
  };

  async function emptyCart() {
    const itemValueArr = cartDataArr?.items ?? [];
    if (itemValueArr && itemValueArr.length > 0) {
      try {
        setLoading(true);
        const resetItems = itemValueArr.map((item: any) => ({
          item_code: item.item_code,
          qty: 0,
        }));

        /**  Remove duplicates item_code */
        const uniqueItemsArr = resetItems.filter(
          (item: any, index: any, self: any) => index === self.findIndex((t: any) => t.item_code === item.item_code)
        );

        const payload = {
          customer_id: parsedUserLoginData.current.customer_id,
          items: uniqueItemsArr,
        };
        const resp = await ProductsService.AddToCart(payload);
        setLoading(false);
        if (resp && resp.message && resp.message.status_code === 200) {
          // localStorage.setItem('quotation_items', '');
          localStorage.removeItem('quotation_items');
          setShowNullDivNotProduct(true);
        } else {
          ToasterService.Error('Something Else try again sometime');
        }
      } catch (err) {
        setLoading(false);
        ToasterService.Error('Server Error!...');
      }
    }
  }

  const handleApply = async (code: string) => {
    setInputCode(code);
    try {
      setLoading(true);
      const resp = await ProductsService.ApplyCoupon(parsedUserLoginData.current.customer_id, code);
      setLoading(false);
      if (resp && resp.data) {
        if (resp && resp.data && resp.data.cart && Object.keys(resp.data.cart).length > 0) {
          if (resp.data.list_of_coupon && resp.data.list_of_coupon.length > 0) {
            listOfCoupen.current = resp.data.list_of_coupon;
          }
          if (resp.data.apply_coupon_code && resp.data.apply_coupon_code !== null) {
            appliedCouponName.current = resp.data.apply_coupon_code?.coupon_name;
          }
          setCartDataArr(resp.data?.cart);
          setShowCoupenModalMobile(false);
          ToasterService.Success('Coupon Applied Successfully!');
        }
      } else {
        ToasterService.Error('Temporary issue, try again later.');
        navigate('/product/cart');
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const handleRemoveCoupon = async () => {
    try {
      setLoading(true);
      const resp = await ProductsService.RemoveCoupen(parsedUserLoginData.current.customer_id, 1);
      setLoading(false);
      if (resp && resp.data) {
        if (resp && resp.data && resp.data.cart && Object.keys(resp.data.cart).length > 0) {
          if (resp.data.list_of_coupon && resp.data.list_of_coupon.length > 0) {
            listOfCoupen.current = resp.data.list_of_coupon;
          }
          if (resp.data.apply_coupon_code && resp.data.apply_coupon_code !== null) {
            appliedCouponName.current = resp.data.apply_coupon_code?.coupon_name;
          } else {
            appliedCouponName.current = null;
          }
          setCartDataArr(resp.data?.cart);
          setShowCoupenModalMobile(false);
          setInputCode('');
          ToasterService.Success('Coupon Removed Successfully!');
        }
      } else {
        ToasterService.Error('Temporary issue, try again later.');
        navigate('/home');
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const states: any = {
    selectedFilter,
    setSelectedFilter,
    cartDataArr,
    listOfCoupen,
    inputCode,
    showCoupenModalMobile,
    setShowCoupenModalMobile,
    appliedCouponName,
    handleRemoveCoupon,
    showNullDivNotProduct,
  };

  return {
    states,
    cartItemPlusMinus,
    emptyCart,
    handleApply,
  };
}
